import { color } from "src/styles/globals";
import styled, { css } from "styled-components";
import { Title as SundayTitle, Body as SundayBody } from "sunday-component";
import { Modal as AntdModal } from "antd";
import CommonButton from "../Button";
import ICTHButton from "../ICTH/Button";
import { ModalBodyText, ModalTitle } from "../ICTH/Typography";

export type DialogAppearance = "ice-cream";

export const Title = styled(SundayTitle).attrs({ level: 5 })`
  margin-top: 4px;
  text-align: center;
  color: ${color.charcoal10};
  font-family: "Noto Sans Thai", sans-serif;
  font-size: 20px;
  font-weight: 600;
`;
export const Body = styled(SundayBody).attrs({ level: 7 })`
  margin-top: 8px;
  text-align: center;
  color: ${color.charcoal09};
  font-family: "Noto Sans Thai", sans-serif;
  font-size: 15px;
  font-weight: 400;
`;

export const IceCreamIcon = styled.img`
  width: 56px;
  height: 56px;
`;

export const IceCreamTitle = styled(ModalTitle)`
  && {
    --typography-color: #202123;
    --typography-t2-font-size: 20px;
    --typography-t2-line-height: 32px;

    margin: 16px auto 0;
    color: #202123;
    white-space: pre-line;
  }
`;

export const IceCreamBody = styled(ModalBodyText)`
  && {
    margin: 8px auto 0;
  }
`;

export const Button = styled(CommonButton).attrs({
  fullWidth: true,
})`
  margin-top: 16px;
`;

export const IceCreamButton = styled(ICTHButton).attrs({
  fullWidth: true,
})`
  &&& {
    height: 48px;
    margin-top: 0;
    border-radius: 999px;
    font-family: var(--typescale-font-th, "Noto Sans Thai"), sans-serif !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    line-height: 24px !important;

    > span,
    * {
      font-size: inherit;
      font-family: inherit;
      font-weight: inherit;
      line-height: inherit;
    }
  }
`;

export const Modal = styled(AntdModal)<{ $appearance?: DialogAppearance }>`
  .ant-modal-content {
    border-radius: 12px;
  }
  .ant-modal-header {
    border-radius: 12px;
  }

  ${({ $appearance }) =>
    $appearance === "ice-cream" &&
    css`
      max-width: calc(100vw - 32px);
      font-family: var(--typescale-font-th, "Noto Sans Thai"), sans-serif;

      &.ant-modal {
        width: 303px !important;
      }

      .ant-modal-content {
        overflow: hidden;
        border: 1px solid var(--color-stroke-default, #d9dbde);
        border-radius: 8px;
        box-shadow: 0 8px 12px rgba(0, 0, 0, 0.1);
      }

      .ant-modal-body {
        padding: 24px;
      }
    `}
`;
